import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetotirupatibalajibusrental() {



  const cardData =
  {
    keyword: 'Pune to Tirupati Balaji Bus Rental Services',
    heading: 'Sanavi Travels: Pune to Tirupati Balaji Bus Rental Services',
    headingDescription: 'Sanavi Travels offers Pune to Tirupati Balaji Bus Rental Services, providing safe, comfortable, and well-organized transportation for devotees, families, and group pilgrimage tours. Our fleet of well-maintained AC and Non-AC buses, mini buses, and luxury coaches ensures spacious seating, smooth long-distance travel, and ample luggage space for a peaceful journey. With experienced drivers, flexible one-way and round-trip bus rental options, transparent pricing, and 24/7 booking support, we ensure punctual and stress-free travel from Pune to Tirupati Balaji. Choose Sanavi Travels for trusted Pune to Tirupati Balaji bus rental services, delivering comfort, safety, and reliability for a divine and memorable pilgrimage experience.',

    top: 'Top Places to Visit in Tirupati Balaji with Sanavi Travels',


"topPlaces": [
  {
    "title": "Tirumala Venkateswara Temple",
    "description": "The Tirumala Venkateswara Temple, popularly known as Tirupati Balaji Temple, is one of the most sacred and richest Hindu temples in the world. Dedicated to Lord Venkateswara, an incarnation of Lord Vishnu, the temple is situated atop the sacred Tirumala hills in Andhra Pradesh. Millions of devotees visit annually, believing that worship here fulfills wishes and grants prosperity. The temple follows ancient Vaikhanasa Agama traditions, and the darshan of Lord Balaji is considered a deeply transformative spiritual experience."
  },
  {
    "title": "Tirumala Hills",
    "description": "The Tirumala Hills are part of the Eastern Ghats and are considered divinely sacred. Covered with lush forests and rich biodiversity, the hills create a serene and spiritually charged atmosphere. The journey to Tirumala, whether by foot via Alipiri or Srivari Mettu footpath, or by road, is regarded as an act of devotion and penance by pilgrims."
  },
  {
    "title": "Srivari Mettu & Alipiri Footpath",
    "description": "The traditional footpaths of Srivari Mettu and Alipiri are sacred pilgrimage routes leading to Tirumala. Devotees walk barefoot while chanting the Lord’s name, symbolizing humility and surrender. These paths pass through forested areas, rest shelters, and spiritual checkpoints, enhancing the devotional journey."
  },
  {
    "title": "Akasa Ganga",
    "description": "Akasa Ganga is a sacred waterfall located on the Tirumala hills, believed to supply holy water for temple rituals. Devotees consider bathing or sprinkling its water as purifying. The site is surrounded by greenery and offers a peaceful retreat within the pilgrimage experience."
  },
  {
    "title": "Sri Kapileswara Swamy Temple",
    "description": "Located at the foothills in Tirupati, Kapileswara Swamy Temple is dedicated to Lord Shiva and is an important stop for pilgrims before visiting Tirumala. The temple is associated with sage Kapila and features a sacred waterfall nearby. It holds great spiritual importance, especially during Mahashivratri."
  },
  {
    "title": "Sri Padmavathi Ammavari Temple",
    "description": "This temple in Tiruchanur is dedicated to Goddess Padmavathi, the consort of Lord Venkateswara. Pilgrims traditionally visit this temple before proceeding to Tirumala. The serene ambiance, rituals, and divine presence make it an essential part of the Tirupati pilgrimage."
  },
  {
    "title": "Silathoranam (Natural Rock Arch)",
    "description": "Silathoranam is a rare natural geological formation and one of the few natural rock arches in Asia. Located near Tirumala, it is believed to be associated with divine legends related to Lord Vishnu. The site attracts both pilgrims and geology enthusiasts."
  },
  {
    "title": "Srivari Pushkarini",
    "description": "Srivari Pushkarini is the sacred temple tank located in front of the Tirumala temple. Devotees take a holy dip here before darshan, believing it cleanses sins and purifies the soul. The tank holds immense ritual significance and enhances the spiritual environment of the temple complex."
  },
  {
    "title": "Tirupati Laddu Prasadam",
    "description": "The Tirupati Laddu is one of the most famous prasadams in India, prepared using a traditional recipe protected by a Geographical Indication (GI) tag. Devotees consider receiving the laddu as a divine blessing, symbolizing the grace of Lord Balaji."
  },
  {
    "title": "Spiritual and Cultural Importance",
    "description": "Tirupati Balaji represents faith, devotion, discipline, and divine grace. The temple’s well-organized rituals, charity activities, and spiritual practices make it a global center of Hindu devotion. Visiting Tirupati is considered a once-in-a-lifetime spiritual journey that leaves devotees with deep peace and fulfillment."
  }
]
,



"services": [
{
"name": "Pune to Tirupati Balaji Bus Rental Services",
"description": "Pune to Tirupati Balaji Bus Rental Services offers well-organized and comfortable bus rental solutions for devotees planning a sacred journey to Tirupati. Ideal for families, religious groups, and organizations, this service provides spacious seating, clean buses, and smooth long-distance travel. With experienced drivers and well-planned routes, passengers can enjoy a safe, peaceful, and spiritually fulfilling journey from Pune to Tirupati Balaji."
},
{
"name": "Tirupati Bus Hire from Pune",
"description": "Tirupati Bus Hire from Pune provides reliable and convenient bus hiring options for pilgrimage and temple tours. Designed for group travel, this service ensures punctual departures, professional chauffeurs, and comfortable buses, making the long journey stress-free and well-coordinated for devotees."
},
{
"name": "AC Bus Pune to Tirupati",
"description": "AC Bus Pune to Tirupati ensures a comfortable and refreshing travel experience with fully air-conditioned buses. Ideal for long-distance journeys, senior citizens, and family trips, these buses offer relaxed seating, smooth suspension, and climate-controlled comfort throughout the pilgrimage."
},
{
"name": "Luxury Bus Tirupati Darshan",
"description": "Luxury Bus Tirupati Darshan provides a premium travel experience with modern interiors, pushback seats, and enhanced onboard comfort. Suitable for VIP groups, corporate pilgrimages, and special religious tours, this service combines style, safety, and comfort for a memorable darshan journey."
},
{
"name": "Religious Tour Bus Pune",
"description": "Religious Tour Bus Pune is specially designed for devotees traveling to Tirupati and other holy destinations. With disciplined drivers, comfortable buses, and organized itineraries, this service ensures a peaceful travel atmosphere, allowing pilgrims to focus on devotion and spiritual experience."
},
{
"name": "Balaji Darshan Bus Rental",
"description": "Balaji Darshan Bus Rental offers dedicated transportation for devotees visiting Lord Venkateswara temple. Spacious seating, smooth driving, and reliable scheduling make this service ideal for organized darshan trips, temple visits, and religious group travel."
},
{
"name": "Family Tirupati Trip Bus",
"description": "Family Tirupati Trip Bus services are designed to provide safe, comfortable, and convenient travel for families of all sizes. With ample space, professional drivers, and smooth long-distance travel, this option ensures a pleasant pilgrimage experience for all age groups."
},
{
"name": "Group Travel Tirupati Bus",
"description": "Group Travel Tirupati Bus offers efficient transportation for large groups, religious organizations, and tour operators. High-capacity buses, experienced chauffeurs, and well-managed schedules ensure safe, comfortable, and coordinated group journeys to Tirupati."
},
{
"name": "Affordable Tirupati Bus Hire",
"description": "Affordable Tirupati Bus Hire provides budget-friendly bus rental services without compromising on comfort or safety. Ideal for devotees, families, and groups seeking economical pilgrimage travel, this service offers transparent pricing and dependable buses for long-distance journeys."
},
{
"name": "Chauffeur Driven Tirupati Bus",
"description": "Chauffeur Driven Tirupati Bus ensures a stress-free pilgrimage with trained drivers handling highways, night travel, and route planning. This service emphasizes passenger safety, punctuality, and smooth driving, making long-distance religious travel comfortable and reliable."
},
{
"name": "Best Tirupati Bus Service Pune",
"description": "Best Tirupati Bus Service Pune is known for quality buses, reliable service, and customer satisfaction. Suitable for family pilgrimages, group tours, and temple visits, it focuses on comfort, disciplined driving, and timely arrivals for a smooth darshan experience."
},
{
"name": "Pune Tirupati Travel Bus",
"description": "Pune Tirupati Travel Bus provides organized and dependable bus travel for devotees heading to Tirupati Balaji. With comfortable seating, experienced drivers, and well-planned routes, this service ensures a safe and enjoyable pilgrimage journey."
},
{
"name": "Pilgrimage Bus Rental Pune",
"description": "Pilgrimage Bus Rental Pune offers comprehensive bus rental solutions for religious tours across South India. Ideal for Tirupati darshan, this service includes well-maintained buses, professional chauffeurs, and reliable scheduling for long and spiritually significant journeys."
},
{
"name": "Online Bus Booking Tirupati",
"description": "Online Bus Booking Tirupati allows devotees to easily reserve buses for Tirupati darshan with quick confirmation and flexible options. Multiple bus types, simple booking steps, and dependable service make pilgrimage planning convenient and hassle-free."
},
{
"name": "Temple Tour Bus",
"description": "Temple Tour Bus services cater to devotees visiting Tirupati and other sacred temples. With comfortable buses, experienced drivers, and organized travel arrangements, this service ensures a smooth, safe, and spiritually focused temple tour experience."
}
],
"tableData": [
["Pune to Tirupati Balaji Bus Rental Services", "Tirupati Bus Hire from Pune"],
["AC Bus Pune to Tirupati", "Luxury Bus Tirupati Darshan"],
["Religious Tour Bus Pune", "Balaji Darshan Bus Rental"],
["Family Tirupati Trip Bus", "Group Travel Tirupati Bus"],
["Affordable Tirupati Bus Hire", "Chauffeur Driven Tirupati Bus"],
["Best Tirupati Bus Service Pune", "Pune Tirupati Travel Bus"],
["Pilgrimage Bus Rental Pune", "Online Bus Booking Tirupati"],
["Temple Tour Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Tirupati Balaji Bus Rental Services with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services from Pune to Tirupati Balaji, perfect for spiritual pilgrimages, group tours, family trips, and long-distance travel."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced to ensure a smooth and enjoyable journey from Pune to Tirupati Balaji."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with the Pune to Tirupati Balaji route, ensuring safe, timely, and stress-free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Tirupati Balaji bus rentals, including fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your pilgrimage journey."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized bus rental options based on your group’s itinerary and travel preferences."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Tirupati Balaji bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services from Pune to Tirupati Balaji?',
    answer: 'Yes, Sanavi Travels offers dependable and comfortable bus rental services from Pune to Tirupati Balaji for pilgrimage and long-distance travel.'
  },
  {
    question: 'How can I book a Pune to Tirupati Balaji bus?',
    answer: 'You can book through our website or by contacting our 24x7 customer support team for assistance.'
  },
  {
    question: 'What types of buses are available for the Pune to Tirupati Balaji route?',
    answer: 'Sanavi Travels offers a range of options including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater buses to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with long-distance travel?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with long-distance routes like Pune to Tirupati Balaji, ensuring a safe journey.'
  },
  {
    question: 'Can I customize my travel itinerary?',
    answer: 'Absolutely — you can customize your pickup, drop-off locations, stops, and schedule according to your travel needs.'
  },
  {
    question: 'Is the bus service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock support to help you plan and book your Pune to Tirupati Balaji bus rental.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Tirupati Balaji bus trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Reddy',
    feedback: 'Booked Pune to Tirupati Balaji bus with Sanavi Travels — comfortable seats, excellent service, and safe travel throughout!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Meena Sharma',
    feedback: 'Our pilgrimage from Pune to Tirupati Balaji was wonderful thanks to Sanavi Travels — punctual pickups and great journey experience!',
    rating: 5
  }
];














































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Pune to Tirupati Balaji Bus Rental Services - Sanavi Travels",
  "description": "Sanavi Travels provides Pune to Tirupati Balaji bus rental services with AC and luxury buses. Perfect for religious tours, Balaji Darshan trips, family trips, group travel, and outstation travel. Affordable and chauffeur-driven buses with online booking.",
  "touristType": "Religious Tour, Pilgrimage, Family Trip, Group Travel, Temple Visit",
  "departureLocation": "Pune",
  "arrivalLocation": "Tirupati, Andhra Pradesh",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "30"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Pune to Tirupati Balaji Bus Rental Services | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Pune to Tirupati Balaji bus rental services by Sanavi Travels. AC and luxury buses for religious tours, Balaji Darshan trips, family trips, and group travel. Affordable, chauffeur-driven, with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/196.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetotirupatibalajibusrental;